/* eslint-disable max-len */
import { useMemo, useState, useEffect, useContext } from "react";
import styled from "styled-components";
import axios from "axios";
import { useScreenClass } from "react-grid-system";
import { useHistory, useLocation } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb";
import { Col, Row } from "../../components/StyledGridSystem";
import _theme from "../../styles/theme";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import Button from "../../components/Button";
import Status from "../../types/enum/Status";
import Icon from "../../components/Icon";
import { StyledText, TextSize, TextStatus } from "../../components/Text";
import { StudentContext } from "../../context/StudentBehalfContext";
import TabGroup, { TabItem } from "../../components/TabGroup";
import Card from "../../components/Card";
import Table from "../../components/Table";
import NullStateTR from "../../components/NullStateTr";
import BasicUserInfo from "../../components/BasicUserInfo";
import PersonalInfo from "../../components/PersonalInfo";
import StudentInfo from "../../components/StudentInfo";
import { UserContext } from "../../context/UserContext";
import Alert from "../../components/Alert";
import ConfirmGradModal from "../../components/ConfirmGradModal";
import LocalAddress from "../../components/LocalAddress";
import HomeAddress from "../../components/HomeAddress";
import FirstEmergencyContact from "../../components/FirstEmergencyContact";
import SecondEmergencyContact from "../../components/SecondEmergencyContact";
import { date } from "yup";
import student from "../../types/Student";
import StudentInformation from "../../components/StudentProgram";
import SnackBar from "../../components/SnackBar";

const RightAlign = styled.div`
  display: flex;
  justify-content: flex-end;
`;
const LeftAlign = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const Header = styled.h2<{ isMobile?: boolean }>`
  font-size: ${({ isMobile }) => (isMobile ? "1.25rem" : "1.75rem")};
  margin-bottom: 0;
`;
const SubHeader = styled.div<{ isMobile?: boolean }>`
  font-size: ${({ isMobile }) => (isMobile ? "0.75rem" : "1rem")};
  display: flex;
  justify-content: flex-start;
`;
const Greytext = styled.div`
  color: ${({ theme }) => theme.color.textSecondary} !important;
  white-space: nowrap;
`;

const RemoveCourse = styled.div`
  color: ${({ theme }) => theme.color.primary};
`;
type Gender = "male" | "female" | "non-binary";
type ViewMode = "view" | "edit";
type UserType = "admin" | "student";

/* eslint-disable camelcase */
interface User {
  student_id: string;
  user_id: string;
  personal_email: string;
  last_name: string;
  middle_name: string;
  first_name: string;
  canvas_id: string;
  gender: Gender | string;
  phone_number: string;
  is_active: Boolean;
  profile_url: string;
  cmkl_email: string;
  cmkl_id: string;
  national_id: string;
  birthdate: string;
  nationality: string;
  expected_graduation_date: string;
  enrolled_date: string;
  activity_type: {
    id: number;
    name: string;
  };
  diploma_name: string;
  local_address: {
    id: string;
    address: string;
    city: string;
    region: string;
    country: string;
    zip_code: string;
  };
  home_address: {
    id: string;
    address: string;
    city: string;
    region: string;
    country: string;
    zip_code: string;
  };
  first_emergency_contact: {
    id: string;
    first_name: string;
    middle_name: string;
    last_name: string;
    relationship: string;
    phone_number: string;
    personal_email: string;
  };
  second_emergency_contact: {
    id: string;
    first_name: string;
    middle_name: string;
    last_name: string;
    relationship: string;
    phone_number: string;
    personal_email: string;
  };
  programs: Array<any>;
  honor: {
    id: string;
    honor_name: string;
  };
  expected_graduation_term: {
    id: string;
    name: string;
  };
}

interface Course {
  CourseName: string;
  TermName: string;
}

interface Student {
  FirstName: string;
  LastName: string;
}

interface User {
  FirstName: string;
  LastName: string;
  is_scholarship_student: boolean;
}

interface ActivityInfo {
  activity_type: string;
  activity: string;
  course: Course;
  created_at: string;
  id: string;
  object: string;
  object_id: string;
  student: Student;
  subject: string;
  subject_id: string;
  token_role: string;
  token_user_id: string;
  user: User;
  user_name: string;
}

// interface FinancialInfo {
//   name: string;
//   account_number: string;
//   program_name: string;
//   years: Record<string, any>;
//   // total_cost: number;
//   // account_balance_accrued: number;
//   // total_income: number;
//   // current_date: string;
// }

interface FinancialInfo {
  description: string;
  invoice_id: string;
  date: string;
  tx_fee_amount: number;
  type: string;
  amount: number;
  currentBalance: number;
}

const showFinanceData = process.env.REACT_APP_SHOW_FINANCE_DATA === "true";

function PersonalInfoPage(this: any, props: any) {
  const location = useLocation();
  const { userId } = props.location.state || {};
  const { role } = props.location.state || {};
  const studentBehalf = useContext(StudentContext);
  const { isBehalf } = useContext(StudentContext);
  const currentUser = useContext(UserContext).user;
  const test = [{ name: "Personal Info", link: "/personalInfo" }];
  const [tab, setTab] = useState(0);
  const [verified, setVerified] = useState<boolean>(false);
  const screenClass = useScreenClass();
  const isMobile = useMemo(() => ["xs", "sm"].includes(screenClass), [
    screenClass,
  ]);
  const [loading, setLoading] = useState<boolean>(false);
  const [financeLoading, setFinanceLoading] = useState<boolean>(false);
  const [financeMessage, setFinanceMessage] = useState<string>("");
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [basicUserInfo, setBasicUserInfo] = useState<{
    user_id: string;
    student_id: string;
    last_name: string;
    middle_name: string;
    first_name: string;
    canvas_id: string;
    cmkl_email: string;
    expected_graduation_date: string;
    diploma_name: string;
    profile_url: string;
    cmkl_id: string;
    national_id: string;
    programs: any[];
    is_scholarship_student: boolean;
  }>({
    user_id: "",
    student_id: "",
    last_name: "",
    middle_name: "",
    first_name: "",
    canvas_id: "",
    cmkl_email: "",
    expected_graduation_date: "",
    diploma_name: "",
    profile_url: "",
    cmkl_id: "",
    national_id: "",
    programs: [],
    is_scholarship_student: false,
  });
  const [personalInfo, setPersonalInfo] = useState({
    user_id: "",
    personal_email: "",
    gender: "",
    phone_number: "",
    nationality: "",
    birthdate: "",
    cmkl_id: "",
    national_id: "",
    is_scholarship_student: false,
  });
  const [firstEmergencyContact, setFirstEmergencyContact] = useState({
    user_id: "",
    student_id: "",
    first_emergency_contact: {
      id: "",
      first_name: "",
      middle_name: "",
      last_name: "",
      relationship: "",
      phone_number: "",
      personal_email: "",
    },
  });
  const [secondEmergencyContact, setSecondEmergencyContact] = useState({
    user_id: "",
    student_id: "",
    second_emergency_contact: {
      id: "",
      first_name: "",
      middle_name: "",
      last_name: "",
      relationship: "",
      phone_number: "",
      personal_email: "",
    },
  });
  const [localAddress, setLocalAddress] = useState({
    user_id: "",
    address: {
      id: "",
      address: "",
      city: "",
      region: "",
      country: "",
      zip_code: "",
    },
  });
  const [homeAddress, setHomeAddress] = useState({
    user_id: "",
    address: {
      id: "",
      address: "",
      city: "",
      region: "",
      country: "",
      zip_code: "",
    },
  });
  const [studentDetail, setStudentDetail] = useState({
    user_id: "",
    student_id: "",
    cmkl_id: "",
    activity_type: {
      id: 0,
      name: "",
    },
    expected_graduation_date: "",
    enrolled_date: "",
    programs: [{}],
    honor: {
      id: "",
      honor_name: "",
    },
    expected_graduation_term: {
      id: "",
      name: "",
    },
  });

  const EmptyFinancialInfo = {
    year: "",
    description: "",
    invoice_id: "",
    invoice_date: "",
    invoice_description: "",
    invoice_amount: 0,
    receipt_date: "",
    payment_description: "",
    received_amount: 0,
    received_method: "",
    income_type: "",
    tax_amount: 0,
    payment_due: "",
    remaining_collectible_amount: 0,
    balance: 0,
  };

  interface FinancialInfo {
    year: string;
    description: string;
    invoice_id: string;
    invoice_date: string;
    invoice_description: string;
    invoice_amount: number;
    receipt_date: string;
    payment_description: string;
    received_amount: number;
    received_method: string;
    income_type: string;
    tax_amount: number;
    payment_due: string;
    remaining_collectible_amount: number;
    balance: number;
  }

  const [activityInfo, setActivityInfo] = useState<ActivityInfo[]>([]);
  const [financialData, setFinancialData] = useState<{
    student_name: string;
    program_name: string;
    account_number: string;
    info: Array<FinancialInfo>;
  }>({
    student_name: "",
    program_name: "",
    account_number: "",
    info: [EmptyFinancialInfo],
  });
  const [snackOpen, setSnackOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");

  const history = useHistory();
  const viewStudentBehalf = (data: any) => {
    if (data) {
      window.localStorage.removeItem("selectedProgram");
      window.localStorage.setItem("behalfStudent", JSON.stringify(data));
      studentBehalf.setCurrentStudent(data);
    }
  };
  const monthDiff = (date1: any, date2: any) => {
    let months;
    months = (date2.getFullYear() - date1.getFullYear()) * 12;
    months -= date1.getMonth();
    months += date2.getMonth();
    return months >= 0 && months <= 3;
  };

  function concat(first: string, middle: string, last: string) {
    if (middle !== "") {
      return `${first} ${middle} ${last}`;
    }
    return `${first} ${last}`;
  }

  const verify = () => {
    setIsConfirmModalOpen(true);
  };
  useEffect(() => {
    // fetchStage();
    userId && fetchUserInfo();
  }, [userId, location]);

  useEffect(() => {
    basicUserInfo.user_id && fetchActivityInfo();
    basicUserInfo.cmkl_email && fetchFinancialData();
  }, [basicUserInfo]);
  const isCurrentUser = () => currentUser.user_id === userId;
  const fetchUserInfo = () => {
    setLoading(true);
    axios
      .get(`/api/v1/users/${userId}`)
      .then((res) => {
        if (res.data.data.user) {
          setVerified(res.data.data.user.information_confirm);
          mapUserData(
            res.data.data.user,
            res.data.data.user.information_confirm
          );
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  let returnStudentId = () => {
    return basicUserInfo.user_id;
  };

  const fetchFinancialData = () => {
    var currentUserId = returnStudentId();
    setFinanceMessage("");
    setFinanceLoading(true);
    axios
      .get(
        `/api/v1/students/finances_airtable/v2?cmkl_email=${basicUserInfo.cmkl_email}`
      )
      .then(async (res) => {
        setFinancialData(res?.data?.[0]);
        setFinanceLoading(false);
      })
      .catch((err) => {
        console.log('error', err.response.data.error);
        setFinanceMessage(err.response.data.error || "Failed to fetch data!!")
        setFinanceLoading(false);
      });
  };
  const fetchActivityInfo = () => {
    var currentUserId = basicUserInfo.user_id;

    setLoading(true);
    axios
      .get(`/api/v1/activity-logs/${currentUserId}`)
      .then(async (res) => {
        if (res.data.data) {
          setActivityInfo(res.data.data);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  const mapUserData = (user: User, verify: boolean) => {
    setBasicUserInfo({
      ...basicUserInfo,
      user_id: user.user_id,
      student_id: user.student_id,
      last_name: user.last_name,
      middle_name: user.middle_name,
      first_name: user.first_name,
      canvas_id: user.canvas_id,
      cmkl_email: user.cmkl_email,
      profile_url: user.profile_url,
      expected_graduation_date: user.expected_graduation_date,
      programs: user.programs,
      diploma_name: verify
        ? user.diploma_name
        : concat(user.first_name, user.middle_name, user.last_name),
      cmkl_id: user.cmkl_id,
      national_id: user.national_id,
      is_scholarship_student: user.is_scholarship_student,
    });
    setLocalAddress({
      ...localAddress,
      user_id: user.user_id,
      address: {
        id: user.local_address?.id,
        address: user.local_address?.address,
        city: user.local_address?.city,
        region: user.local_address?.region,
        country: user.local_address?.country,
        zip_code: user.local_address?.zip_code,
      },
    });
    setHomeAddress({
      ...homeAddress,
      user_id: user.user_id,
      address: {
        id: user.home_address?.id,
        address: user.home_address?.address,
        city: user.home_address?.city,
        region: user.home_address?.region,
        country: user.home_address?.country,
        zip_code: user.home_address?.zip_code,
      },
    });
    setPersonalInfo({
      ...personalInfo,
      user_id: user?.user_id,
      nationality: user?.nationality,
      birthdate: user?.birthdate,
      personal_email: user?.personal_email,
      gender: user?.gender,
      phone_number: user?.phone_number,
      cmkl_id: user?.cmkl_id,
      national_id: user?.national_id,
    });
    setFirstEmergencyContact({
      ...firstEmergencyContact,
      user_id: user?.user_id,
      student_id: user?.student_id,
      first_emergency_contact: {
        id: user.first_emergency_contact?.id,
        first_name: user.first_emergency_contact?.first_name,
        middle_name: user.first_emergency_contact?.middle_name,
        last_name: user.first_emergency_contact?.last_name,
        relationship: user.first_emergency_contact?.relationship,
        phone_number: user.first_emergency_contact?.phone_number,
        personal_email: user.first_emergency_contact?.personal_email,
      },
    });
    setSecondEmergencyContact({
      ...secondEmergencyContact,
      user_id: user?.user_id,
      student_id: user?.student_id,
      second_emergency_contact: {
        id: user.second_emergency_contact?.id,
        first_name: user.second_emergency_contact?.first_name,
        middle_name: user.second_emergency_contact?.middle_name,
        last_name: user.second_emergency_contact?.last_name,
        relationship: user.second_emergency_contact?.relationship,
        phone_number: user.second_emergency_contact?.phone_number,
        personal_email: user.second_emergency_contact?.personal_email,
      },
    });

    setStudentDetail({
      ...studentDetail,
      cmkl_id: user?.cmkl_id,
      user_id: user?.user_id,
      student_id: user?.student_id,
      expected_graduation_date: user?.expected_graduation_date,
      enrolled_date: user?.enrolled_date,
      activity_type: {
        id: user?.activity_type.id,
        name: user?.activity_type.name,
      },
      programs: user?.programs,
      // {
      //   id: user?.program.id,
      //   name: user?.program.name,
      // },
      honor: {
        id: user?.honor.id,
        honor_name: user?.honor.honor_name,
      },
      expected_graduation_term: {
        id: user?.expected_graduation_term.id,
        name: user?.expected_graduation_term.name,
      },
    });
  };
  const confirmGraduation = (diploma: any) => {
    setLoading(true);
    axios
      .put(`/api/v1/students/${basicUserInfo.student_id}/confirm`, {
        diploma_name: diploma,
      })
      .then(() => {
        setIsConfirmModalOpen(false);
        const path = "/personalInfo";
        // history.push(path);
        history.push({
          pathname: path,
          state: {
            userId: basicUserInfo.user_id,
            role:
              currentUser.role && currentUser.role !== ""
                ? currentUser.role
                : "student",
          },
        });
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  return (
    <>
      <SnackBar
        isOpen={snackOpen}
        setOpen={setSnackOpen}
        type="success"
        message={message}
      />
      <ConfirmGradModal
        isOpen={isConfirmModalOpen}
        setOpen={setIsConfirmModalOpen}
        confirmGraduation={confirmGraduation}
        diplomaName={basicUserInfo.diploma_name}
      />
      <Row>
        <Col>
          <Breadcrumb path={test} />
        </Col>
      </Row>
      {((currentUser.role === "admin" && isBehalf) ||
        currentUser.role === "student") &&
        monthDiff(
          new Date(),
          new Date(basicUserInfo.expected_graduation_date)
        ) && (
          <FlexBox style={{ marginBottom: "16px" }}>
            <FlexGrow>
              <Alert
                style={{
                  backgroundColor: "#e3f1fd",
                  color: "#1c5f9d",
                  border: "2px solid #1c5f9d",
                }}
              >
                {!isMobile && (
                  <FlexBox>
                    <FlexGrow style={{ flexGrow: 0, marginRight: "16px" }}>
                      <Icon name="alert-octagon" />
                    </FlexGrow>
                    <FlexGrow grow={3}>
                      <b>
                        {" "}
                        We are currently preparing the information for
                        graduation process,
                      </b>
                      please click “Verify” to review your personal information
                    </FlexGrow>
                    <FlexGrow style={{ flexGrow: 0, whiteSpace: "nowrap" }}>
                      {verified ? (
                        <StyledText
                          textSize={TextSize.default}
                          status={TextStatus.success}
                        >
                          <Icon
                            mr={1}
                            style={{ verticalAlign: "middle" }}
                            name="verified"
                          />
                          Verified
                        </StyledText>
                      ) : (
                        // eslint-disable-next-line jsx-a11y/anchor-is-valid
                        <a
                          style={{ color: "#1c5f9d", cursor: "pointer" }}
                          onClick={() => {
                            verify();
                          }}
                        >
                          Verify{" "}
                          <Icon
                            mr={1}
                            style={{ verticalAlign: "middle" }}
                            name="chevron-right-s"
                          />
                        </a>
                      )}
                    </FlexGrow>
                  </FlexBox>
                )}
                {isMobile && (
                  <div>
                    <div>
                      <Icon name="alert-octagon" />
                      <b>
                        {" "}
                        We are currently preparing the information for
                        graduation process,{" "}
                      </b>
                      please click “Verify” to review your personal information
                    </div>
                    {verified ? (
                      <StyledText
                        textSize={TextSize.default}
                        status={TextStatus.success}
                      >
                        <Icon
                          mr={1}
                          style={{ verticalAlign: "middle" }}
                          name="verified"
                        />
                        Verified
                      </StyledText>
                    ) : (
                      <a style={{ color: "#1c5f9d" }}>
                        Verify <Icon mr={1} name="chevron-right-s" />
                      </a>
                    )}
                  </div>
                )}
              </Alert>
            </FlexGrow>
          </FlexBox>
        )}
      <Row justify="between">
        <Col>
          <FlexBox alignItems="flex-start">
            <FlexGrow>
              <Header isMobile={isMobile}>
                {basicUserInfo.first_name} {basicUserInfo.last_name}
              </Header>

              <Greytext>
                {isCurrentUser() && currentUser.role === "admin" ? (
                  <SubHeader isMobile={isMobile}>Admin Profile</SubHeader>
                ) : (
                  <SubHeader isMobile={isMobile}>Student Profile</SubHeader>
                )}
              </Greytext>
            </FlexGrow>
            {role && role === "admin" && userId && userId !== "" && (
              <div style={{ marginLeft: "auto" }}>
                <RightAlign>
                  <Button
                    style={{ marginRight: 10 }}
                    status={Status.primary}
                    backgroundColor="#CB092B"
                    as="a"
                    onClick={() =>
                      history.push(`/courses/enroll-student?userId=${basicUserInfo.student_id}&first_name=${basicUserInfo.first_name}&name=${basicUserInfo.first_name+" "+basicUserInfo.last_name}&stu_user_id=${basicUserInfo.user_id}`)
                    }
                  >
                    {" "}
                    <Icon name="time-history" mr={0.5} />
                    {"View Enrollment History"}
                  </Button>
                  <Button
                    status={Status.primary}
                    backgroundColor="#CB092B"
                    as="a"
                    onClick={() => viewStudentBehalf(basicUserInfo)}
                  >
                    <Icon name="eye" mr={0.5} />
                    {isMobile ? "Browse as" : "Browse Cube as"}
                    <StyledText style={{ paddingLeft: _theme.spacing.xs }}>
                      {basicUserInfo.first_name}
                    </StyledText>
                  </Button>
                </RightAlign>
              </div>
            )}
          </FlexBox>
        </Col>
      </Row>
      {/* <UserInfo></UserInfo> */}
      {!loading ? (
        <>
          <TabGroup>
            <TabItem active={tab === 0} onClick={() => setTab(0)}>
              {isCurrentUser() && currentUser.role === "admin" ? (
                <>Admin Information</>
              ) : (
                <>Student Information</>
              )}
            </TabItem>
            <TabItem active={tab === 1} onClick={() => setTab(1)}>
              Activity Log
            </TabItem>
            <TabItem active={tab === 2} onClick={() => setTab(2)}>
              Financial Details
            </TabItem>
          </TabGroup>
          {tab === 0 && (
            <>
              <Row>
                <Col>
                  <BasicUserInfo
                    defViewMode={"view"}
                    userType={role}
                    userInfo={basicUserInfo}
                    information_confirm={verified}
                    reloadParent={fetchUserInfo.bind(this)}
                  />
                   {basicUserInfo.student_id && (
                    <StudentInformation
                      defViewMode={"view"}
                      userType={role}
                      userInfo={basicUserInfo}
                      information_confirm={verified}
                      reloadParent={(message: string) => {
                        fetchUserInfo();
                        setMessage(message);
                        setSnackOpen(true);
                      }}
                    />
                  )}
                  <PersonalInfo
                    defViewMode={"view"}
                    userType={role}
                    userInfo={personalInfo}
                    information_confirm={verified}
                    reloadParent={fetchUserInfo.bind(this)}
                  />
                  <LocalAddress
                    defViewMode={"view"}
                    userType={role}
                    userInfo={localAddress}
                    information_confirm={verified}
                    reloadParent={fetchUserInfo.bind(this)}
                  />
                  <HomeAddress
                    defViewMode={"view"}
                    userType={role}
                    userInfo={homeAddress}
                    information_confirm={verified}
                    reloadParent={fetchUserInfo.bind(this)}
                  />
                  <FirstEmergencyContact
                    defViewMode={"view"}
                    userType={role}
                    userInfo={firstEmergencyContact}
                    information_confirm={verified}
                    reloadParent={fetchUserInfo.bind(this)}
                  />
                  <SecondEmergencyContact
                    defViewMode={"view"}
                    userType={role}
                    userInfo={secondEmergencyContact}
                    information_confirm={verified}
                    reloadParent={fetchUserInfo.bind(this)}
                  />
                 
                </Col>
              </Row>
            </>
          )}
          {tab === 1 && (
            <>
              <Row>
                <Col>
                  <Card>
                    <FlexBox
                      alignItems="flex-start"
                      style={{ marginBottom: _theme.spacing.x2 }}
                    >
                      <FlexGrow>
                        <h3>Activity Log</h3>
                      </FlexGrow>
                    </FlexBox>
                    <Table hoverable>
                      <thead>
                        {!isMobile && (
                          <tr>
                            <th
                              style={{
                                width: "20%",
                                fontSize: "14px",
                                padding: "8px",
                              }}
                            >
                              Timestamp
                            </th>
                            <th
                              style={{
                                width: "55%",
                                fontSize: "14px",
                                padding: "8px",
                              }}
                            >
                              Activity
                            </th>
                            <th
                              style={{
                                width: "25%",
                                fontSize: "14px",
                                padding: "8px",
                              }}
                            >
                              Done by
                            </th>
                          </tr>
                        )}
                      </thead>
                      <tbody>
                        {!loading ? (
                          <>
                            {activityInfo.map((data: any, index: number) => (
                              <ActivityLogItem item={data}></ActivityLogItem>
                            ))}
                          </>
                        ) : (
                          <NullStateTR>
                            <Icon mr={1} name="spinner" spin />
                            Loading...
                          </NullStateTR>
                        )}
                      </tbody>
                    </Table>
                  </Card>
                </Col>
              </Row>
            </>
          )}

          {tab === 2 && (
            <>
              <FinancialTable
                isMobile={isMobile}
                item={financialData}
                student_name={financialData.student_name}
                program_name={financialData.program_name}
                account_number={financialData.account_number}
                loading={financeLoading}
                financeMessage={financeMessage}
              ></FinancialTable>
            </>
          )}
        </>
      ) : (
        <>
          <Icon mr={1} name="spinner" spin />
          Loading...
        </>
      )}
    </>
  );
}

type ActivityLogProps = {
  item: ActivityInfo;
};

const ActivityLogItem = ({ item }: ActivityLogProps) => {
  const formattedDate = new Date(item.created_at).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const formattedTime = new Date(item.created_at).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  return (
    <>
      <tr>
        <td>
          <StyledText style={{ fontSize: "14px" }}>
            <StyledText status={TextStatus.muted}>
              {formattedDate} {formattedTime}
            </StyledText>
          </StyledText>
        </td>
        <td>
          <StyledText style={{ fontSize: "14px" }}>
            {item.activity}
            {/* {item?.activity_type == "ADD" && (
              <>Enrolled in course {item?.course.CourseName}</>
            )}
            {item?.activity_type == "DROP" && (
              <>Dropped course {item?.course.CourseName}</>
            )}

            {item?.activity_type == "WITHDRAW" && (
              <>Withdrew from course {item?.course.CourseName}</>
            )} */}
          </StyledText>
        </td>
        <td>
          <StyledText style={{ fontSize: "14px" }} status={TextStatus.muted}>
            {item.user_name}
            {/* {item?.token_role === "admin" && <>Omega Admin</>}
            {item?.token_role !== "admin" && (
              <>
                {item?.user?.FirstName} {item?.user?.LastName}
              </>
            )} */}
          </StyledText>
        </td>
      </tr>
    </>
  );
};

const FinancialItem = (item: FinancialInfo) => {

  return (
    <>
      <tr>
        <td style={{ padding: "8px", textAlign: "left" }}>
          <StyledText style={{ fontSize: "14px" }}>{item?.date}</StyledText>
        </td>
        <td style={{ padding: "8px", textAlign: "left" }}>
          <StyledText
            style={{
              fontSize: "16px",
              fontWeight: item?.type === "Payment" ? "" : "bold",
              // color: item?.type === "Payment" ? "#008300" : "#ff541e",
            }}
          >
            {item?.type}
          </StyledText>
        </td>
        <td style={{ padding: "8px", textAlign: "left" }}>
          <StyledText style={{ fontSize: "14px", fontWeight: item?.type === "Payment" ? "" : "bold", }}>
            {item?.invoice_id}
          </StyledText>
        </td>
        <td style={{ padding: "8px", textAlign: "left", fontWeight: item?.type === "Payment" ? "" : "bold", }}>
          <StyledText style={{ fontSize: "14px" }}>
            {item?.description}
          </StyledText>
        </td>
        <td style={{ padding: "8px", textAlign: "right" }}>
          <StyledText style={{ fontSize: "14px", fontWeight: item?.type === "Payment" ? "" : "bold", }}>{item?.amount?.toLocaleString() || ""}</StyledText>
        </td>
        <td style={{ padding: "8px", textAlign: "right" }}>
          <StyledText style={{ fontSize: "16px", fontWeight: item?.type === "Payment" ? "" : "bold" }}>{item?.currentBalance?.toLocaleString() || ""}</StyledText>
        </td>
      </tr>
    </>
  );
};

type FinancialDataProps = {
  item: any | undefined;
  isMobile: boolean;
  loading?: boolean;
  student_name?: string;
  program_name?: string;
  account_number?: string;
  financeMessage? : string;
};

const FinancialTable = ({
  item,
  isMobile,
  loading,
  student_name,
  program_name,
  account_number,
  financeMessage
}: FinancialDataProps) => {
 let runningBalance = 0;
  const reversedFinance = item?.finance?.slice().reverse(); 

  const calculatedFinancialItems: any[] = [];

  reversedFinance?.forEach((i: any, index: number) => {

    if (i?.type === "Invoice") {
      runningBalance += i?.amount;
    } else if (i?.type === "Payment") {
      runningBalance -= i?.amount;
    }

    const financialItem = {
      ...i,
      currentBalance: runningBalance, 
    };

    calculatedFinancialItems.push(financialItem); 
  });

  const latestFirstFinancialItems = calculatedFinancialItems.reverse();
  if(financeMessage && financeMessage !== ""){
    return (
      <Row>
        <Col>
          <Card>
            <Alert
              style={{
                backgroundColor: "#fdecea",
                color: "#611a15",         
                border: "2px solid #611a15",
              }}
            >
              <FlexBox>
                <FlexGrow style={{ flexGrow: 0, marginRight: "16px" }}>
                  <Icon name="alert-triangle" />
                </FlexGrow>
                <FlexGrow grow={3}>
                  <b>{financeMessage}</b>
                </FlexGrow>
              </FlexBox>
            </Alert>
          </Card>
        </Col>
      </Row>
    );
  } 

  return (
    <Row>
      <Col>
        <Card>
          {!loading && <FlexBox
            alignItems="flex-start"
            style={{ marginBottom: _theme.spacing.x2 }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "auto auto",
                gap: "0 8px",
              }}
            >
              <div>
                <StyledText fontWeight="bold">Student:</StyledText>
              </div>
              <div>
                <StyledText>{student_name}</StyledText>
              </div>
              <div>
                <StyledText fontWeight="bold">Account:</StyledText>
              </div>
              <div>
                <StyledText>{account_number}</StyledText>
              </div>
              <div>
                <StyledText fontWeight="bold">Program:</StyledText>
              </div>
              <div>
                <StyledText>{program_name}</StyledText>
              </div>
            </div>
          </FlexBox>}

          <Table hoverable>
            <thead>
              {!isMobile && (
                <>
                  <tr>
                    <th style={{ width: "10%", padding: "8px" }}>Date</th>
                    <th style={{ width: "10%", padding: "8px" }}>Type</th>

                    <th style={{ width: "20%", padding: "8px" }}>Invoice #</th>
                    <th style={{ width: "35%", padding: "8px" }}>
                      Description
                    </th>
                    <th style={{ width: "10%", padding: "8px" , textAlign:'right' }}>Amount</th>

                    <th style={{ width: "15%", padding: "8px", textAlign:'right' }}>Balance</th>
                  </tr>
                </>
              )}
            </thead>
            <tbody>
              {!loading ? (
                 <>
                  {latestFirstFinancialItems.map((i: any, index: number) => (
                    <FinancialItem {...i} />
                  ))}
                </>
              ) : (
                <NullStateTR>
                  <Icon mr={1} name="spinner" spin />
                 <span style={{color:"#ba2932"}}> Retrieving information from external finance system - please be patient</span>
                </NullStateTR>
              )}
            </tbody>
          </Table>
        </Card>
      </Col>
    </Row>
  );
};

export default PersonalInfoPage;
